<template>
  <div :class="$style.container">
    <TabList
      :activeTab="activeTabIndex"
      :class="$style.tabList"
      :customActiveTabStyle="$style.activeTab"
      :customNavStyle="$style.tabNav"
      :customTabStyle="$style.tabLink"
      :tabs="tabs"
      @active-tab-change="handleActiveTabChange"
    />
  </div>
</template>

<script>
import { ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import { mapGetters } from 'vuex';
import CommandQueueItemTable from 'client/Commands/CommandQueueItemTable.vue';
import CommandResultItemTable from 'client/Commands/CommandResultItemTable.vue';
import CommandTemplateManageItemTable from 'client/Commands/CommandTemplateManageItemTable.vue';
import CommandsMainPanel from 'client/Commands/CommandsMainPanel.vue';
import MainPanelMixin from 'components/MainPanel/mixins/MainPanelMixin';
import MspState from 'client/components/models/MspState';
import TabList from 'components/TabList/TabList.vue';

const settingsModule = StoreModuleMap[ItemTypeConsts.settings];

export default {
  name: 'CommandsResultsMainPanel',

  components: {
    TabList,
  },

  mixins: [MainPanelMixin],

  props: {
    activeTab: {
      type: String,
      default: 'commands',
    },
  },

  computed: {
    ...mapGetters(settingsModule, [
      'isAdminWithBilling',
      'isAdmin',
    ]),
    activeTabIndex() {
      return this.tabs.findIndex(tab => tab.path.substring(1) === this.activeTab);
    },
    settingsIconStyle() {
      return {
        'padding-right': '5px',
        top: '2px',
        position: 'relative',
        color: 'var(--jc-color-informational-base)',
      };
    },

    tabs() {
      const manageTemplateTab = {
        path: '/commands/managetemplates',
        title: 'Manage Command Templates',
        component: CommandTemplateManageItemTable,
        icon: 'settings',
        iconStyle: this.settingsIconStyle,
      };

      const allTabs = [
        {
          path: '/commands',
          title: 'Commands',
          component: CommandsMainPanel,
          componentProps: {
            isAsideOpen: this.isAsideOpen,
            gettingStartedPanelItemType: this.gettingStartedPanelItemType,
            itemType: this.itemType,
            setGettingStartedTooltipVisibility: this.showTooltip,
            selectedModelId: this.selectedModelId,
            setSelectedModelId: this.setSelectedModelId,
            viewport: this.viewport,
          },
        },
        {
          path: '/commandqueues',
          title: 'Queued',
          component: CommandQueueItemTable,
        },
        {
          path: '/commandresults',
          title: 'Results',
          component: CommandResultItemTable,
          componentProps: {
            isAsideOpen: this.isAsideOpen,
            gettingStartedPanelItemType: this.gettingStartedPanelItemType,
            itemType: this.itemType,
            selectedModelId: this.selectedModelId,
            setSelectedModelId: this.setSelectedModelId,
            viewport: this.viewport,
          },
        },
      ];

      if (this.$hasFeatureFlag(this.$featureFlags.commandTemplateEdit)
        && MspState.isAnMsp
        && (this.isAdminWithBilling || this.isAdmin)) {
        allTabs.push(manageTemplateTab);
      }

      return allTabs;
    },
  },

  methods: {
    handleActiveTabChange(tabIndex) {
      const { path } = this.tabs[tabIndex];
      this.$router.push(path);
    },
  },
};
</script>

<style module>
@value (jcGrey, jcGrey600) from '~css/brand-colors.css';

.activeTab a {
  border-bottom: solid 2px var(--jcPrimary);
  color: jcGrey600;
}

.announcement {
  left: 60px;
  position: absolute;
  top: 55px;
}

.tabList {
  height: 100%;
}

.tabLink {
  color: jcGrey !important;
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 4px;
}

.tabNav {
  margin: 20px 0 10px 20px !important;
}

.tabNav li:nth-child(4) {
  margin-left: auto;
}

.tabNav li:nth-child(4) a {
  color: var(--jc-color-informational-base) !important;
  font-size: 1rem;
}
</style>
